<template>
  <div class="modal" @mousedown="closeModal">
    <div class="card">
      <div class="card-header">
        <h1>Delete Preset</h1>
        <p>Are you sure you want to delete <u>{{preset.name}}</u>? This action cannot be undone.</p>
      </div>
      <div class="card-footer">
        <button class="button danger" @click.prevent="attemptDelete">
          <img
            v-if="pending"
            src="/loading.svg"
            alt="Loading"
            class="loading"
          />
          <span v-else>Delete</span>
        </button>
        <p class="error" v-if="error">{{ error }}</p>
      </div>
    </div>
  </div>
</template>

<script>
import { deletePreset } from "@/api";

export default {
  name: "DeletePresetModal",
  props: {
    preset: Object,
  },
  data() {
    return {
      error: "",
      pending: false,
    };
  },
  methods: {
    async attemptDelete() {
      try {
        this.pending = true;
        await deletePreset(this.preset.id);
        this.$emit("closeModal");
      } catch (err) {
        console.error("Failed to delete preset", err);
      } finally {
        this.pending = false;
      }
    },
    closeModal(event) {
      if (event.target.className != "modal") {
        return;
      }
      this.$emit("closeModal");
    },
  },
  emits: ["closeModal"],
};
</script>

<style scoped>
.card-header {
  margin-bottom: 0px;
}
</style>